import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.protobuf = bracketIndenting()
